/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEditorRight: {
  name: 'editor-right';
  data: string;
} = {
  name: 'editor-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 .5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5h-4Zm.5 8v-7h3v7h-3ZM5.354 2.646a.5.5 0 0 0-.708.707L5.793 4.5H2a.5.5 0 0 0 0 1h3.793L4.647 6.645a.5.5 0 0 0 .706.708l2-2a.5.5 0 0 0 0-.706l-2-2.001ZM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
